import { IconLoader } from '@ui/src';
import DocumentsItems from './document-items';
import DocumentRowHeaderProps from './document-row-header';
import Card from '../card/card';
import { CustomerDocument } from '../../../hoc/customers/types';
import { DocumentsTypes } from './types';

import cn from './documents.module.css';

const Documents = ({
  onSelect,
  onGroupSelect,
  // blockView,
  customerId,
  customerType,
  isLoading,
  onGroupByIdSelect,
  selectedCategory,
  currentCategoryDocuments,
  allDocumentsSelected,
  allDocumentsTotal,
  documentsByCategoryTotal,
  selectedDocumentsyategoryId,
  setRenamePopupVisible,
  setSelectedDocumentToRename,
  documentsIsFetching,
  selectedStatuses,
  setSelectedStatuses,
  sort,
  onChangeSort,
  sortProp,
  status,
  updateExpiredDocumentsState,
}: DocumentsTypes): React.JSX.Element => (
  <div className={cn.documents}>
    <Card transparent>
      <DocumentRowHeaderProps
        type={selectedCategory?.id as string}
        onGroupSelect={onGroupSelect}
        onGroupByIdSelect={onGroupByIdSelect}
        documents={currentCategoryDocuments as CustomerDocument[]}
        status={status}
        depricated={Boolean(
          currentCategoryDocuments
            ?.filter(
              (document) =>
                document?.documentCategoryId === selectedCategory?.id ||
                document?.category === selectedCategory?.category,
            )
            ?.find((document) => document.category),
        )}
        documentsSelected={
          selectedCategory?.id === 'all'
            ? allDocumentsSelected
            : selectedDocumentsyategoryId
        }
        total={
          selectedCategory?.id === 'all'
            ? allDocumentsTotal
            : documentsByCategoryTotal
        }
        selectedStatuses={selectedStatuses}
        setSelectedStatuses={setSelectedStatuses}
        sort={sort}
        onChangeSort={onChangeSort}
        sortProp={sortProp}
      />
      <DocumentsItems
        documents={currentCategoryDocuments as CustomerDocument[]}
        onSelect={onSelect}
        type={selectedCategory?.id as string}
        // blockView={blockView}
        customerId={customerId}
        customerType={customerType}
        setRenamePopupVisible={setRenamePopupVisible}
        setSelectedDocumentToRename={setSelectedDocumentToRename}
        status={status}
        updateExpiredDocumentsState={updateExpiredDocumentsState}
      />
    </Card>
    {isLoading && (
      <div
        className={`${cn.documentsLoader} ${
          documentsIsFetching ? cn.documentsIsFetching : ''
        }`}
      >
        <IconLoader />
      </div>
    )}

    {!currentCategoryDocuments?.length && !isLoading && (
      <div className={cn.emptyDocuments}>No documents yet</div>
    )}
  </div>
);

export default Documents;
